import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { PartenaireService } from '../../../@core/data/rest/partenaire/partenaire-service';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { Partenaire } from '../../../@core/data/model/partenaire';
import { PlanTarifaireService } from '../../../@core/data/rest/plantarifaire/plantarifaire-service';
import { AuthService } from '../../../auth/auth.service';
import { TaxeService } from '../../../@core/data/rest/taxe/taxe-service';
import { Taxe } from '../../../@core/data/model/taxe';
import { TaxeFormComponent } from '../../setting/settingform/taxeform.component';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-partenaire',
  templateUrl: './partenaireform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class PartenaireFormComponent implements OnInit {

  @Input() partenaireEdit: Partenaire;
  @Input() typePartenaire: string;
  @Input() labelPartner: string;

  select: number;

  selectedItems = [];
  dropdownSettings = {};

  selectedItemsTaxes = [];
  dropdownSettingsTaxes = {};

  constructor(
      protected dialogRef: NbDialogRef<PartenaireFormComponent>,
      public authservice: AuthService,
      public partenaireService: PartenaireService,
      public taxeService: TaxeService,
      public sharedMethods: SharedMethods,
      private dialogService: NbDialogService,
      public plantarifaireService: PlanTarifaireService) {
  }


  ngOnInit(): void {

    this.authservice.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    this.dropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'designation',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
    };

    this.dropdownSettingsTaxes = {
      singleSelection: false,
      idField: 'id',
      textField: 'designation',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'recherche',
      noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
      closeDropDownOnSelection: true,
  };

    // chargement des plans tarifaires
    if (this.plantarifaireService.plantarifaires === undefined) {
      this.plantarifaireService.getPlantarifaire().then( plans => {});
    }

    // chargement des taxes
    if (this.taxeService.taxes === undefined || this.taxeService.taxes.length === 0) {

        this.taxeService.getTaxes().then( taxes => {

    });

   }

   if (this.partenaireEdit.taxes !== undefined && this.partenaireEdit.taxes !== null) {
      this.selectedItemsTaxes = this.partenaireEdit.taxes;
   }


    if (this.partenaireEdit.plan_tarifaire !== undefined && this.partenaireEdit.plan_tarifaire !== null) {
        this.selectedItems = [this.partenaireEdit.plan_tarifaire];
    }

  }

  onItemSelect(item: any) {
    // tslint:disable-next-line:no-console
    /* for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {
      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.item_id ) {
        this.facture.partenaire = this.partenaireService.getLocalPartner(this.typePartner)[i];
      }
    } */
    this.partenaireEdit.plan_tarifaire = item;
  }

  onDeSelect(item: any) {
    this.partenaireEdit.plan_tarifaire = null;
  }


  cancel() {
    if (this.partenaireService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }


  onItemSelectTaxes(item: any) {
    
    if ( this.partenaireEdit.taxes !== undefined && this.partenaireEdit.taxes !== null) {

      let itemIndex: number;
      itemIndex = this.partenaireEdit.taxes.findIndex(itm => itm.id === item.id);

      if (itemIndex === -1)
      this.partenaireEdit.taxes.push(item);

    } else {

      this.partenaireEdit.taxes = [];
      this.partenaireEdit.taxes.push(item);

    }

  }

  onSelectAllTaxes(items) {

    // const fours = plainToClass( Partenaire, items);

    this.partenaireEdit.taxes = items;

  }

  onDeSelectAllTaxes(event) {
    this.partenaireEdit.taxes = [];
  }

  onDeSelectTaxes(item: any) {
    let itemIndex: number;
    itemIndex = this.partenaireEdit.taxes.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.partenaireEdit.taxes.splice(itemIndex, 1);
  }

  submit() {
    // alert(JSON.stringify(this.partenaireEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    let valid: Validator;
    valid = this.sharedMethods.validatePartner(this.partenaireEdit, this.partenaireService.getLocalPartner('client'));

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.partenaireService.iSconnecting === false) {


            this.partenaireService.savePartner(this.partenaireEdit, this.typePartenaire).then( partenaire => {

                /* this.partenaireEdit.id = partenaire.id;
                this.dialogRef.close(this.partenaireEdit); */

                this.dialogRef.close(plainToClass(Partenaire, partenaire as Object));
                // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


 }

 addTaxes() {

    const taxe = new Taxe;
    taxe.type_calcul = 'pourcentage';

    const closeOnBackdropClick = false;
    this.dialogService.open(TaxeFormComponent, {
      closeOnBackdropClick,
      context: {
        taxeEdit : taxe,
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined) {

          if ( this.partenaireEdit.taxes !== undefined && this.partenaireEdit.taxes !== undefined && this.partenaireEdit.taxes !== null)
          this.partenaireEdit.taxes.push(data);
          else
          this.partenaireEdit.taxes = [data];

          this.selectedItemsTaxes = this.partenaireEdit.taxes;

          this.sharedMethods.sweetalert('success', ' Création taxe effectué', '');

        }
    });
   
 }


}
